// import React, {FC, useState, useEffect, memo} from "react";
// import {
//     getLabelName,
//     isArabicCurrentLanguage,
//     formatValue,
// } from "../../../utils";
// import { Form } from "react-bootstrap";
// import {
//     ControlSizeType,
//     FormatValueType,
//     LabelSizeType,
// } from "../../../models";
//
// type TextBoxType = "text" | "number" | "checkbox" | "textarea" | "password" |"quantity"|"price";
//
// export const TextBoxV2: FC<{
//     labelName: string;
//     inputName: string;
//     inputValue:
//         | string
//         | ReadonlyArray<string>
//         | number
//         | boolean
//         | undefined
//         | null;
//     errorText?: string | null;
//     placeHolder?: string | undefined;
//     isMandatory?: boolean | null;
//     isReadOnly?: boolean | undefined;
//     isVisible?: boolean | undefined;
//     onChange?: any | undefined;
//     onBlur?: any | undefined;
//     onKeyPress?: (value: string) => void;
//     type?: TextBoxType | null;
//     controlSize?: ControlSizeType;
//     labelSize?: LabelSizeType;
//     inputRef?: React.Ref<HTMLInputElement>;
//     formatType?: FormatValueType;
//     preventNegative?: boolean;
//     optimizeTyping?: boolean; // New prop to enable optimization
// }> = ({
//           labelName,
//           inputName,
//           inputValue,
//           errorText,
//           placeHolder,
//           isMandatory = false,
//           isReadOnly = false,
//           isVisible = true,
//           type = "text",
//           onChange,
//           onBlur,
//           onKeyPress,
//           controlSize = "col flex-form-control",
//           labelSize = "form-label",
//           inputRef,
//           formatType = "none",
//           preventNegative = false,
//           optimizeTyping = false, // Default to false for backward compatibility
//       }) => {
//     if (!isVisible) return null;
//
//     // Only use optimization for text input types
//     const shouldOptimize = optimizeTyping &&
//         (type === "text" || type === "textarea" || type === "password");
//
//     // Local state for optimized input value
//     const [localValue, setLocalValue] = useState(
//         type === "checkbox" ? Boolean(inputValue) : formatValue(inputValue, formatType)
//     );
//
//     // Keep local state synced with external value
//     useEffect(() => {
//         if (type === "checkbox") {
//             setLocalValue(Boolean(inputValue));
//         } else {
//             setLocalValue(formatValue(inputValue, formatType));
//         }
//     }, [inputValue, type, formatType]);
//
//     // Determine which value to use for rendering
//     const displayValue = shouldOptimize
//         ? localValue
//         : (type === "checkbox" ? Boolean(inputValue) : formatValue(inputValue, formatType));
//
//     //#region variables
//     const cssPrefix: string = isArabicCurrentLanguage() ? "_ar" : "_en";
//     const errorClassName =
//         errorText !== null && errorText !== undefined
//             ? `error${cssPrefix}`
//             : `success${cssPrefix}`;
//     const inputClassName: string =
//         type === "checkbox" ? "" : `form-control ${errorClassName}`;
//     const isInputField: boolean = type !== "textarea";
//     const translatedPlaceholder = getLabelName(placeHolder || labelName);
//     //#endregion
//
//     //#region function
//     const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//         // For checkbox, always use the original onChange
//         if (type === "checkbox") {
//             if (onChange) {
//                 onChange(e);
//             }
//             return;
//         }
//
//         // For optimized text fields, only update local state
//         if (shouldOptimize) {
//             setLocalValue(e.target.value);
//         }
//         // For non-optimized fields, pass through to original handler
//         else if (onChange) {
//             onChange(e);
//         }
//     };
//
//     const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//         // For optimized fields, update formik on blur
//         if (shouldOptimize && onChange) {
//             // Create a synthetic event to pass the local value
//             const syntheticEvent = {
//                 target: {
//                     name: inputName,
//                     value: localValue
//                 }
//             };
//
//             // Update formik with our local state value
//             onChange(syntheticEvent);
//         }
//
//         // Always call the original onBlur handler
//         if (onBlur) {
//             onBlur(e);
//         }
//     };
//
//     const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//         if (preventNegative && (type === "number" || type === "quantity" || type === "price")) {
//             if (event.key === "-" || event.key === "e") {
//                 event.preventDefault();
//                 return;
//             }
//         }
//
//         if (event.key === "Enter") {
//             event.preventDefault();
//
//             // For optimized fields, update formik on Enter key
//             if (shouldOptimize && onChange) {
//                 const syntheticEvent = {
//                     target: {
//                         name: inputName,
//                         value: localValue
//                     }
//                 };
//                 onChange(syntheticEvent);
//             }
//
//             if (onKeyPress) {
//                 const value = typeof displayValue === 'string'
//                     ? displayValue
//                     : String(displayValue);
//                 onKeyPress(value);
//             }
//         }
//     };
//
//     const renderError = () => {
//         if (errorText) {
//             return (
//                 <Form.Control.Feedback
//                     type="invalid"
//                     className="position-relative d-block"
//                 >
//                     {errorText}
//                 </Form.Control.Feedback>
//             );
//         }
//         return null;
//     };
//     //#endregion
//
//     //#region html
//     return (
//         <>
//             <div className={controlSize} style={{ gap: 15, alignItems: "baseline" }}>
//                 {labelName && (
//                     <label htmlFor={inputName} className={labelSize}>
//                         {getLabelName(labelName)}
//                         {isMandatory && <span className="asterisk">*</span>}
//                     </label>
//                 )}
//                 <div className="flex-grow-1">
//                     {isInputField ? (
//                         <input
//                             id={inputName}
//                             key={inputName}
//                             name={inputName}
//                             className={inputClassName}
//                             type={type === "checkbox" ? "checkbox" : (type || "text")}
//                             placeholder={translatedPlaceholder}
//                             readOnly={isReadOnly}
//                             checked={type === "checkbox" ? Boolean(displayValue) : undefined}
//                             value={type !== "checkbox" ? displayValue : undefined}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             onKeyDown={handleKeyDown}
//                             onWheel={(event) => {
//                                 event.currentTarget.blur();
//                             }}
//                             ref={inputRef}
//                             min={
//                                 (type === "number" || type === "quantity" || type === "price") && preventNegative
//                                     ? "0"
//                                     : undefined
//                             }
//                             step={
//                                 type === "price"
//                                     ? "0.01"
//                                     : type === "quantity"
//                                         ? "1"
//                                         : type === "number"
//                                             ? "0.00001"
//                                             : undefined
//                             }
//                         />
//                     ) : (
//                         <textarea
//                             id={inputName}
//                             key={inputName}
//                             name={inputName}
//                             className={inputClassName}
//                             rows={3}
//                             placeholder={translatedPlaceholder}
//                             readOnly={isReadOnly}
//                             value={displayValue}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             onKeyDown={handleKeyDown}
//                             style={{ width: "100%" }}
//                         />
//                     )}
//                     {renderError()}
//                 </div>
//             </div>
//         </>
//     );
//     //#endregion
// };
//
// export default memo(TextBoxV2);



import React, {FC, useState, useEffect, memo} from "react";
import {
    getLabelName,
    isArabicCurrentLanguage,
    formatValue
} from "../../../utils";
import { Form } from "react-bootstrap";
import {CommonTextBoxProps} from "./commonTextBoxProps";


type TextBoxV2Props = CommonTextBoxProps & {
    optimizeTyping?: boolean;
    resetKey?: string;
};

export const TextBoxV2: FC<TextBoxV2Props> = ({
                                                  labelName,
                                                  inputName,
                                                  inputValue,
                                                  errorText,
                                                  placeHolder,
                                                  isMandatory = false,
                                                  isReadOnly = false,
                                                  isVisible = true,
                                                  type = "text",
                                                  onChange,
                                                  onBlur,
                                                  onKeyPress,
                                                  controlSize = "col flex-form-control",
                                                  labelSize = "form-label",
                                                  inputRef,
                                                  formatType = "none",
                                                  preventNegative = false,
                                                  optimizeTyping = false,
                                                  resetKey = '',
                                                  inputContainerClassName,
                                                  row = 3,
                                              }) => {
    if (!isVisible) return null;

    // Only use optimization for text types (not checkboxes, etc.)
    const shouldOptimize = optimizeTyping &&
        (type === "text" || type === "textarea" || type === "password");

    // Local state for input value
    const [localValue, setLocalValue] = useState(
        type === "checkbox" ? Boolean(inputValue) : formatValue(inputValue, formatType)
    );

    // Update local state when input value or resetKey changes
    useEffect(() => {
        if (type === "checkbox") {
            setLocalValue(Boolean(inputValue));
        } else {
            setLocalValue(formatValue(inputValue, formatType));
        }
    }, [inputValue, type, formatType, resetKey]);

    //#region variables
    const cssPrefix: string = isArabicCurrentLanguage() ? "_ar" : "_en";
    const errorClassName =
        errorText !== null && errorText !== undefined
            ? `error${cssPrefix}`
            : `success${cssPrefix}`;
    const inputClassName: string =
        type === "checkbox" ? "" : `form-control ${errorClassName}`;
    const isInputField: boolean = type !== "textarea";
    const translatedPlaceholder = getLabelName(placeHolder || labelName);
    //#endregion

    //#region function
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // For checkbox, always pass through to onChange
        if (type === "checkbox") {
            if (onChange) {
                onChange(e);
            }
            return;
        }

        // For optimized text fields, update local state only
        if (shouldOptimize) {
            setLocalValue(e.target.value);
        }
        // For non-optimized fields, pass through to original handler
        else if (onChange) {
            onChange(e);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // For optimized fields, update parent state on blur
        if (shouldOptimize && onChange) {
            const syntheticEvent = {
                target: {
                    name: inputName,
                    value: localValue
                }
            };
            onChange(syntheticEvent);
        }

        // Call the original onBlur handler
        if (onBlur) {
            onBlur(e);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (preventNegative && (type === "number" || type === "quantity" || type === "price")) {
            if (event.key === "-" || event.key === "e") {
                event.preventDefault();
                return;
            }
        }

        if (event.key === "Enter") {
            event.preventDefault();

            // For optimized fields, update parent state on Enter key
            if (shouldOptimize && onChange) {
                const syntheticEvent = {
                    target: {
                        name: inputName,
                        value: localValue
                    }
                };
                onChange(syntheticEvent);
            }

            if (onKeyPress) {
                const value = typeof localValue === 'string'
                    ? localValue
                    : String(localValue);
                onKeyPress(value);
            }
        }
    };

    const renderError = () => {
        if (errorText) {
            return (
                <Form.Control.Feedback
                    type="invalid"
                    className="position-relative d-block"
                >
                    {errorText}
                </Form.Control.Feedback>
            );
        }
        return null;
    };
    //#endregion

    //#region html
    return (
        <>
            <div className={controlSize} style={{ gap: 15, alignItems: "baseline" }}>
                {labelName && (
                    <label htmlFor={inputName} className={labelSize}>
                        {getLabelName(labelName)}
                        {isMandatory && <span className="asterisk">*</span>}
                    </label>
                )}
                <div className={ inputContainerClassName ? inputContainerClassName : "flex-grow-1"}>
                    {isInputField ? (
                        <input
                            id={inputName}
                            //key={`${inputName}-${resetKey}`} // Key to force re-render
                            name={inputName}
                            className={inputClassName}
                            type={type === "checkbox" ? "checkbox" : (type || "text")}
                            placeholder={translatedPlaceholder}
                            readOnly={isReadOnly}
                            checked={type === "checkbox" ? Boolean(localValue) : undefined}
                            value={type !== "checkbox" ? localValue : undefined}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                            onWheel={(event) => {
                                event.currentTarget.blur();
                            }}
                            ref={inputRef}
                            min={
                                (type === "number" || type === "quantity" || type === "price") && preventNegative
                                    ? "0"
                                    : undefined
                            }
                            step={
                                type === "price"
                                    ? "0.01"
                                    : type === "quantity"
                                        ? "1"
                                        : type === "number"
                                            ? "0.00001"
                                            : undefined
                            }
                        />
                    ) : (
                        <textarea
                            id={inputName}
                            key={`${inputName}-${resetKey}`} // Key to force re-render
                            name={inputName}
                            className={inputClassName}
                            rows={row}
                            placeholder={translatedPlaceholder}
                            readOnly={isReadOnly}
                            value={localValue}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                            style={{ width: "100%" }}
                        />
                    )}
                    {renderError()}
                </div>
            </div>
        </>
    );
    //#endregion
};

export default memo(TextBoxV2);